export default __webpack_public_path__ + "static/25-target-d1ba5607127e5afcc052ad5056e811bb.png";